import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';

import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class WlcontextResource {
  private baseUri = '/prl/wlcontexts';

  constructor(private ApiService: ApiService) {}

  // GET
  findWlcontexts(params: {
    expertizeId: Docorga.interfaces.naturalTypes.NExpertizeObjectId;
  }): Observable<Array<Docorga.interfaces.wlContext.IWlcontextJson>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }
}
